<template>
    <div>
        <modal :show.sync="addTravel" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="travelName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad de viajes *</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad de viajes"
                                placeholder="cantidad de viajes"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('cantidad de viajes')"
                                v-model="travelQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="travelValue"></vue-numeric>
                </div>
                <div v-if="travelTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{setFormat(travelTotalComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddTravel()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addTravelToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editTravel" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="vehículo"
                                :disabled="travelLocked"
                                placeholder="vehículo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('vehículo')"
                                v-model="travelName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad de viajes *</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad de viajes"
                                placeholder="cantidad de viajes"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('cantidad de viajes')"
                                v-model="travelQuantity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="travelValue"></vue-numeric>
                </div>
                <div v-if="travelTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{setFormat(travelTotalComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditTravel()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editTravelToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addVehicle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar Vehículo</h6>
                <div class="form-group">
                    <label>Vehículo *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del vehículo"
                                placeholder="nombre del vehículo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del vehículo')"
                                v-model="vehicleName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="vehicleValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddVehicle()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addVehicleToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editVehicle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar Vehículo</h6>
                <div class="form-group">
                    <label>Vehículo *</label>
                    <fg-input   tabindex="2"
                                type="text"
                                name="vehículo"
                                :disabled="vehicleLocked"
                                placeholder="vehículo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('vehículo')"
                                v-model="vehicleName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="vehicleValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditVehicle()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editVehicleToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Vehicles -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Seleccione el vehículo</h6>
            </div>
            <div class="card-body">
                <div v-if="salesVehicles.length == 0" class="alert alert-danger">
                    <span>No hay vehículos agregados en el cruce de ventas</span>
                </div>
                <div class="form-group">
                    <label>Vehículo *</label>
                    <fg-input   name="vehiculo"
                                tabindex="2"
                                v-validate="modelValidations.periodicity"
                                :error="getError('vehiculo')"
                                v-model="salesVehicleSelection">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salesVehicleSelection">
                                    <el-option
                                        v-for="(vehicle, index) in salesVehicles"
                                        :key="index"
                                        :value="vehicle.vehicleName"
                                        :label="vehicle.vehicleName">
                                </el-option>
                        </el-select>
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Vehicles -->
        <!-- Travel -->
        <card v-if="salesVehicleSelection != null && indexSalesVehicle != null" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos por viaje</h6>
            </div>
            <div class="card-body">

                <el-table v-if="salesVehicles[indexSalesVehicle].actualTravels.length" :data="salesVehicles[indexSalesVehicle].actualTravels"  ref="travelsTable"  @row-dblclick="showEditTravelsMethod" highlight-current-row @current-change="handleTravelCurrentChange">
                    <el-table-column label="Gasto" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Cantidad de viajes" property="quantity"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.total)}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div>
                    <p-button
                        @click="addTravelMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentTravelRow"
                        @click="editTravelMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentTravelRow && currentTravelRow.locked == false"
                        @click="removeTravelMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar gasto
                    </p-button>
                </div>
                <div v-if="indexSalesVehicle != null" class="alert alert-warning mt-2">
                    <span>Costo gastos por viaje al mes: {{setFormat(salesVehicles[indexSalesVehicle].totalTravels)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Travel -->
        <!-- add expenses -->
        <modal :show.sync="addExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                tabindex="2"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="expenseFrecuency">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expenseFrecuency">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{expenseFrecuency}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./add expenses-->
        <!--edit expenses-->
        <modal :show.sync="editExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="expenseFrecuency">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expenseFrecuency">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{expenseFrecuency}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="6" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editExpenseToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /edit expenses -->
         <!-- Expenses -->
        <card v-if="salesVehicleSelection != null && indexSalesVehicle != null" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos del vehículo</h6>
            </div>
            <div class="card-body">
                <el-table v-if="salesVehicles[indexSalesVehicle].actualExpenses.length" :data="salesVehicles[indexSalesVehicle].actualExpenses"  ref="expensesTable"  @row-dblclick="showEditExpensesMethod" highlight-current-row @current-change="handleExpenseCurrentChange">
                    <el-table-column label="Gasto" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Frecuencia" property="frecuency"></el-table-column>
                    <el-table-column label="Mes a causar" property="month"></el-table-column>
                </el-table>

                <div>
                    <p-button
                        @click="addExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentExpenseRow && currentExpenseRow.name != 'Combustible'"
                        @click="editExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar gasto
                    </p-button>
                    <br>
                    <p-button v-if="currentExpenseRow && currentExpenseRow.locked == false"
                        @click="removeExpenseMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar gasto
                    </p-button>
                </div>
                <div v-if="indexSalesVehicle != null" class="alert alert-warning mt-2">
                    <span>TOTAL GASTO POR VIAJE: {{setFormat(salesVehicles[indexSalesVehicle].totalExpenses)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Expenses -->
        <!-- add Taxes -->
        <modal :show.sync="addTax" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar impuesto</h6>
                <div class="form-group">
                    <label>Impuesto *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="nombre del impuesto"
                                placeholder="nombre del impuesto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del impuesto')"
                                v-model="taxName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="taxPeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="taxPeriodicity">
                            <!-- <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option> -->
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{taxPeriodicity}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="6" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="taxValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddTax()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addTaxToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./add Taxes-->
        <!--edit Taxes-->
        <modal :show.sync="editTax" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar impuesto</h6>
                <div class="form-group">
                    <label>impuesto *</label>
                    <fg-input   tabindex="7"
                                type="text"
                                name="impuesto"
                                :disabled="taxLocked"
                                placeholder="impuesto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('impuesto')"
                                v-model="taxName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="taxPeriodicity">
                            <el-select
                                    :disabled="taxLocked"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="taxPeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="alert alert-info">
                    <span>Asegúrate de agregar el valor de forma {{taxPeriodicity}}</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="8" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="taxValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditTax()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editTaxToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /edit Taxes -->
        <!--Taxes -->
        <card v-if="salesVehicleSelection != null && indexSalesVehicle != null" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Impuestos</h6>
            </div>
            <div class="card-body">
                <el-table v-if="salesVehicles[indexSalesVehicle].actualTaxes.length" :data="salesVehicles[indexSalesVehicle].actualTaxes"  ref="taxesTable"   @row-dblclick="showEditTaxesMethod" highlight-current-row @current-change="handleTaxCurrentChange">
                    <el-table-column label="Impuesto" property="name"></el-table-column>
                    <el-table-column label="Periodicidad" property="periodicity"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button
                        @click="addTaxMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar impuesto
                    </p-button>
                    <br>
                    <p-button v-if="currentTaxRow"
                        @click="editTaxMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar impuesto
                    </p-button>
                    <br>
                    <p-button v-if="currentTaxRow && currentTaxRow.locked == false"
                        @click="removeTaxMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar impuesto
                    </p-button>
                </div>
                <div v-if="indexSalesVehicle != null" class="alert alert-warning mt-2">
                    <span>Costo impuestos al mes: {{setFormat(salesVehicles[indexSalesVehicle].totalTaxes)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!-- /Taxes -->
        <div v-if="totalCostsPyme != 0" class="alert alert-success">
            <span>Costos totales mes: {{ setFormat(totalCostsPyme)}}</span>
        </div>
        <div v-if="this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="totalCostsPyme != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Services/Expenses'
    import Travels from 'src/util/Services/Travels'
    import Taxes from 'src/util/Services/Taxes'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            totalCostsPyme: 0,
            form: {
                average_selection: '',
            },
            indexSalesVehicle: null,
            salesVehicles: [],
            salesVehicleSelection: null,
            alertFlag: true,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            vehicles : [],
            travels : [],
            expenses : [],
            taxes: [],
            actualVehicles: [],
            actualTravels: [],
            actualExpenses: [],
            actualTaxes: [],
            currentRow: null,
            currentTaxRow: null,
            currentTravelRow: null,
            currentExpenseRow: null,
            addExpense: false,
            editExpense: false,
            addVehicle: false,
            editVehicle: false,
            addTravel: false,
            editTravel: false,
            addTax: false,
            editTax: false,
            addVehicleIndex: null,
            monthlyNumber: '',
            vehicleName: '',
            vehicleValue: '',
            vehicleLocked: false,
            expenseName: '',
            expenseFrecuency: '',
            expenseMonth: '',
            expenseValue: '',
            expenseLocked: false,
            travelName: '',
            travelQuantity: '',
            travelValue: '',
            travelTotal: null,
            travelLocked: false,
            taxName: '',
            taxValue: '',
            taxPeriodicity: '',
            taxLocked: false,
            products: [

            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
            },
        }
        },
        watch: {
            salesVehicleSelection: function (newIndex) {
                const index = this.salesVehicles.findIndex(vehicle => vehicle.vehicleName === newIndex);
                if (index !== -1) {
                    this.indexSalesVehicle = index;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else if(newVal == '') {
                    this.periodicity_days = 0;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {

                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            travelTotalComputed() {
                 // Verifica si 'travelQuantity' y 'travelValue' son válidos
                const isQuantityValid = this.travelQuantity && !isNaN(this.travelQuantity);
                const isValueValid = this.travelValue && !isNaN(this.travelValue);

                // Si ambos son válidos, realiza la multiplicación, de lo contrario retorna 0
                const result = isQuantityValid && isValueValid
                ? this.travelQuantity * this.travelValue
                : 0;

                // Asigna el resultado a la variable 'travelTotal'
                this.travelTotal = result;

                return result;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allTravelsMonthlyCostComputed() {
                return 0;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allExpensesMonthlyCostComputed() {
                // Verifica si 'actualExpenses' tiene valores, de lo contrario retorna 0
                if (this.indexSalesVehicle != null) {
                    if (!this.salesVehicles[this.indexSalesVehicle].actualExpenses || this.salesVehicles[this.indexSalesVehicle].actualExpenses.length === 0) {
                        return 0;
                    }

                    // Suma los valores de 'value' en la lista 'actualExpenses'
                    return this.salesVehicles[this.indexSalesVehicle].actualExpenses.reduce((total, expense) => {
                        return total + (expense.value || 0); // Asegúrate de que 'value' sea un número o 0
                    }, 0);
                }
                else {
                    return 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allVehiclesMonthlyCostComputed() {
                // Verifica si 'actualTravels' tiene valores, de lo contrario retorna 0
                if (!this.actualVehicles || this.actualVehicles.length === 0) {
                return 0;
                }

                // Suma los valores de 'value' en la lista 'actualVehicles'
                return this.actualVehicles.reduce((total, vehicle) => {
                return total + (vehicle.value || 0); // Asegúrate de que 'value' sea un número o 0
                }, 0);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allTaxesMonthlyCostComputed() {
                if (this.indexSalesVehicle != null) {
                    var sum = 0;
                    for (let i=0;i<this.salesVehicles[this.indexSalesVehicle].actualTaxes.length;i++) {
                        if (this.salesVehicles[this.indexSalesVehicle].actualTaxes[i].periodicity == 'Mensual') {
                            sum = sum + this.salesVehicles[this.indexSalesVehicle].actualTaxes[i].value;
                        }
                        else {
                            sum = sum + (this.salesVehicles[this.indexSalesVehicle].actualTaxes[i].value/ 12);
                        }

                    }
                    return sum
                }
                else {
                    return 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                // Usa reduce para calcular los totales de cada categoría
                const totals = this.salesVehicles.reduce((acc, vehicle) => {
                    acc.totalTravels += vehicle.totalTravels || 0; // Suma totalTravels
                    acc.totalTaxes += vehicle.totalTaxes || 0; // Suma totalTaxes
                    acc.totalExpenses += vehicle.totalExpenses || 0; // Suma totalExpenses
                    return acc; // Devuelve el acumulador
                }, {
                    totalTravels: 0,
                    totalTaxes: 0,
                    totalExpenses: 0
                });

                // Devuelve el total de todos los costos
                return totals.totalTravels + totals.totalTaxes + totals.totalExpenses; // Total de costos
            }
        },
        methods: {
            updateOilExpenses() {
                let totalCombustible = 0;
                for (let vehicle of this.salesVehicles) {
                    if(vehicle.vehicleName == this.salesVehicleSelection){
                        for (let travel of vehicle.actualTravels) {
                            if (travel.name && travel.name.includes('Combustible')) {
                                totalCombustible += travel.total || 0;
                            }
                        }
                    }
                }

                if (this.salesVehicles[this.indexSalesVehicle].actualExpenses && this.salesVehicles[this.indexSalesVehicle].actualExpenses.length > 0) {
                    // Actualiza directamente el valor sin considerar el valor previo
                    this.salesVehicles[this.indexSalesVehicle].actualExpenses[0].value = totalCombustible;
                    this.salesVehicles[this.indexSalesVehicle].actualExpenses[0].frecuency = 'Mensual'; // Actualiza la frecuencia
                }
            },
            getTotalRouteQuantity(vehicle) {
                return vehicle.routes.reduce((total, route) => total + route.routeQuantity, 0);
            },
            // Método para calcular el total de costos
            calculateTotalCosts() {
                // Usando reduce para calcular la suma total de viajes, impuestos y gastos
                const totals = this.salesVehicles.reduce((acc, vehicle) => {
                    acc.totalTravels += vehicle.totalTravels || 0; // Suma totalTravels
                    acc.totalTaxes += vehicle.totalTaxes || 0;     // Suma totalTaxes
                    acc.totalExpenses += vehicle.totalExpenses || 0; // Suma totalExpenses
                    return acc; // Devuelve el acumulador
                }, {
                    totalTravels: 0,
                    totalTaxes: 0,
                    totalExpenses: 0
                });

                // Devuelve la suma total
                this.totalCostsPyme = (totals.totalTravels + totals.totalTaxes + totals.totalExpenses);
            },
             /**
             * This function recalculates the total taxes for each vehicle.
             */
            recalculateTotalTaxes() {
                this.salesVehicles.forEach(vehicle => {
                    // Verifica que actualTaxes exista y sea un array
                    if (vehicle.actualTaxes && Array.isArray(vehicle.actualTaxes)) {
                        // Calcula el total de actualTaxes
                        const total = vehicle.actualTaxes.reduce((acc, tax) => {
                            return acc + (tax.value || 0); // Sumar 'value' o 0 si no está definido
                        }, 0);
                        // Divide el total entre 12 y redondea sin decimales
                        vehicle.totalTaxes = Math.round(total / 12);
                    } else {
                        // Asigna 0 si no hay actualTaxes
                        vehicle.totalTaxes = 0;
                    }
                });
                this.calculateTotalCosts();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             recalculateTotalExpenses() {
                this.salesVehicles.forEach(vehicle => {
                    // Verifica que actualExpenses exista y sea un array
                    if (vehicle.actualExpenses && Array.isArray(vehicle.actualExpenses)) {
                        // Calcula el total de actualExpenses
                        vehicle.totalExpenses = vehicle.actualExpenses.reduce((acc, expense) => {
                            return acc + (expense.value || 0); // Sumar 'total' o 0 si no está definido
                        }, 0);
                    } else {
                        // Asigna 0 si no hay actualExpenses
                        vehicle.totalExpenses = 0;
                    }
                });
                this.calculateTotalCosts();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            recalculateTotalTravels() {
                this.salesVehicles.forEach(vehicle => {
                    // Verifica que actualTravels exista y sea un array
                    if (vehicle.actualTravels && Array.isArray(vehicle.actualTravels)) {
                        // Calcula el total de actualTravels
                        vehicle.totalTravels = vehicle.actualTravels.reduce((acc, travel) => {
                            return acc + (travel.total || 0); // Sumar 'total' o 0 si no está definido
                        }, 0);
                    } else {
                        // Asigna 0 si no hay actualTravels
                        vehicle.totalTravels = 0;
                    }
                });
                this.calculateTotalCosts();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditVehiclesMethod (row) {
                this.vehicleName= row.name;
                this.vehicleValue= row.value;
                this.vehicleLocked = row.locked;
                this.editVehicle = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditExpensesMethod (row) {
                if(row.name == 'Combustible') {
                    this.showNotificationError('Este campo no puede ser editado');
                }
                else {
                    this.expenseName= row.name;
                    this.expenseValue= row.value;
                    this.expenseFrecuency= row.frecuency;
                    this.expenseMonth= row.month;
                    this.expenseLocked = row.locked;
                    this.editExpense = true;
                }
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditTravelsMethod (row) {
                this.travelName= row.name;
                this.travelValue= row.value;
                this.travelQuantity= row.quantity;
                this.travelLocked = row.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditTaxesMethod (row) {
                this.taxName= row.name;
                this.taxValue= row.value;
                this.taxLocked = row.locked;
                this.taxPeriodicity = row.periodicity;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleTravelCurrentChange(currentRow, oldCurrentRow) {
                this.currentTravelRow = currentRow;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleExpenseCurrentChange(currentRow, oldCurrentRow) {
                this.currentExpenseRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleTaxCurrentChange(currentRow, oldCurrentRow) {
                this.currentTaxRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editVehicleToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.salesVehicles[this.indexSalesVehicle].actualVehicles.indexOf(this.currentRow);
                            this.salesVehicles[this.indexSalesVehicle].actualVehicles[index].name = this.vehicleName;
                            this.salesVehicles[this.indexSalesVehicle].actualVehicles[index].value = this.vehicleValue;
                            this.resetVehicle();
                            this.currentRow = null;
                            this.$refs.vehiclesTable.setCurrentRow();
                            this.editVehicle = false;
                            this.showNotificationSuccess('Vehículo editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.salesVehicles[this.indexSalesVehicle].actualExpenses.indexOf(this.currentExpenseRow);
                            this.salesVehicles[this.indexSalesVehicle].actualExpenses[index].name = this.expenseName;
                            this.salesVehicles[this.indexSalesVehicle].actualExpenses[index].value = this.expenseValue;
                            this.resetExpense();
                            this.currentExpenseRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editExpense = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                            this.recalculateTotalExpenses();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var index = this.salesVehicles[this.indexSalesVehicle].actualTaxes.indexOf(this.currentTaxRow);
                            this.salesVehicles[this.indexSalesVehicle].actualTaxes[index].name = this.taxName;
                            this.salesVehicles[this.indexSalesVehicle].actualTaxes[index].value = this.taxValue;
                            this.salesVehicles[this.indexSalesVehicle].actualTaxes[index].periodicity = this.taxPeriodicity;
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.taxesTable.setCurrentRow();
                            this.editTax = false;
                            this.showNotificationSuccess('Impuesto editado correctamente');
                            this.recalculateTotalTaxes();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editTravelToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.travelName == '' && this.travelValue == null) {
                            this.showNotificationError('Los campos no han sido diligenciados');
                        }
                        else {
                            var index = this.salesVehicles[this.indexSalesVehicle].actualTravels.indexOf(this.currentTravelRow);
                            this.salesVehicles[this.indexSalesVehicle].actualTravels[index].name = this.travelName;
                            this.salesVehicles[this.indexSalesVehicle].actualTravels[index].quantity = parseInt(this.travelQuantity);
                            this.salesVehicles[this.indexSalesVehicle].actualTravels[index].value = this.travelValue;
                            this.salesVehicles[this.indexSalesVehicle].actualTravels[index].total = this.travelTotal;
                            this.updateOilExpenses();
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.travelsTable.setCurrentRow();
                            this.editTravel = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                            this.recalculateTotalTravels();
                            this.recalculateTotalExpenses();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addVehicleMethod (row) {
                // this.addProductIndex = row;
                this.resetVehicle();
                this.addVehicle = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelMethod (row) {
                // this.addProductIndex = row;
                this.resetTravel();
                this.addTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxMethod (row) {
                // this.addProductIndex = row;
                this.resetTax();
                this.addTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addVehicleToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            this.salesVehicles[this.indexSalesVehicle].actualVehicles.push({
                                name: this.vehicleName,
                                value: this.vehicleValue,
                                locked: false
                            })
                            this.resetVehicle();
                            this.addVehicle = false;
                            this.showNotificationSuccess('Vehículo agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '' || this.expenseFrecuency == '') {
                            this.showNotificationError('Faltan campos por diligenciar');
                        }
                        else {
                            this.salesVehicles[this.indexSalesVehicle].actualExpenses.push({
                                name: this.expenseName,
                                value: this.expenseValue,
                                frecuency: this.expenseFrecuency,
                                month: 'Todos',
                                locked: false
                            })
                            this.resetExpense();
                            this.addExpense = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                            this.recalculateTotalExpenses();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.travelName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            this.salesVehicles[this.indexSalesVehicle].actualTravels.push({
                                name: this.travelName,
                                quantity: parseInt(this.travelQuantity),
                                value: this.travelValue,
                                total: this.travelTotal,
                                locked: false
                            })
                            this.resetTravel();
                            this.updateOilExpenses();
                            this.addTravel = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                            this.recalculateTotalTravels();
                            this.recalculateTotalExpenses();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            this.salesVehicles[this.indexSalesVehicle].actualTaxes.push({
                                name: this.taxName,
                                periodicity: this.taxPeriodicity,
                                value: this.taxValue,
                                locked: false
                            })
                            this.resetTax();
                            this.addTax = false;
                            this.showNotificationSuccess('Impuesto agregado correctamente');
                            this.recalculateTotalTaxes();
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetVehicle () {
                this.vehicleName = '';
                this.vehicleValue = '';
                this.vehicleLocked = false;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';
                this.expenseFrecuency = '';
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetTravel () {
                this.travelName = '';
                this.travelQuantity = '';
                this.travelValue = '';
                this.travelTotal = null;
                this.travelLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetTax () {
                this.taxName = '';
                this.taxValue = '';
                this.taxPeriodicity = 'Anual';
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editVehicleMethod () {
                this.vehicleName= this.currentRow.name;
                this.vehicleValue= this.currentRow.value;
                this.vehicleLocked = this.currentRow.locked;
                this.editVehicle = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseMethod () {
                this.expenseName= this.currentExpenseRow.name;
                this.expenseValue= this.currentExpenseRow.value;
                this.expenseLocked = this.currentExpenseRow.locked;
                this.expenseFrecuency = this.currentExpenseRow.frecuency;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editTravelMethod () {
                this.travelName= this.currentTravelRow.name;
                this.travelQuantity= this.currentTravelRow.quantity;
                this.travelValue= this.currentTravelRow.value;
                this.travelLocked = this.currentTravelRow.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxMethod () {
                this.taxName= this.currentTaxRow.name;
                this.taxPeriodicity= this.currentTaxRow.periodicity;
                this.taxValue= this.currentTaxRow.value;
                this.taxLocked = this.currentTaxRow.locked;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeVehicleMethod () {
                this.actualVehicles.splice(this.actualVehicles.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeExpenseMethod () {
                this.salesVehicles[this.indexSalesVehicle].actualExpenses.splice(this.salesVehicles[this.indexSalesVehicle].actualExpenses.indexOf(this.currentExpenseRow),1);
                this.currentExpenseRow = null;
                this.recalculateTotalExpenses();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeTravelMethod () {
                this.salesVehicles[this.indexSalesVehicle].actualTravels.splice(this.salesVehicles[this.indexSalesVehicle].actualTravels.indexOf(this.currentTravelRow),1);
                this.currentTravelRow = null;
                this.updateOilExpenses();
                this.recalculateTotalTravels();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeTaxMethod () {
                this.salesVehicles[this.indexSalesVehicle].actualTaxes.splice(this.salesVehicles[this.indexSalesVehicle].actualTaxes.indexOf(this.currentTaxRow),1);
                this.currentTaxRow = null;
                this.recalculateTotalTaxes();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddVehicle () {
                this.addVehicle = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddTravel () {
                this.addTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditVehicle () {
                this.editVehicle = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditTravel () {
                this.editTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddTax () {
                this.addTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditTax () {
                this.editTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                if (this.totalCostsPyme != 0) {
                    this.costs.push({
                        vehicles: this.salesVehicles,
                        totalCosts: this.totalCostsPyme
                    })
                    this.$store.dispatch('setPymeTransportCosts', this.costs).then(()=>{
                        // this.$store.dispatch('setTotalCostsComputed', this.allCostsComputed).then(()=>{
                        this.$store.dispatch('setTotalCostsComputed', 0).then(()=>{
                            this.$store.dispatch('setCostsDataPopulate', true).then(()=>{
                                var vm = this;
                                swal({
                                    title: '¿Deseas agregar información de Salarios?',
                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                    text: 'Si aceptas, podrás agregar o editar la información de los Salarios',
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push('/asessments/new_asessment/customer/others/salary');
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    if (dismiss == 'cancel') {
                                        swal({
                                            title: '¿Deseas agregar información de Obligaciones Financieras?',
                                            text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonText: 'Si, aceptar',
                                            cancelButtonText: 'No, continuar',
                                            confirmButtonClass: 'btn btn-success btn-fill',
                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                            buttonsStyling: false
                                        }).then(() => {
                                            vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                                        }, function (dismiss) {
                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                            if (dismiss == 'cancel') {
                                                vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                            }
                                            else {
                                                swal({
                                                    title: 'Cancelado',
                                                    text: 'El analista no ha continuado',
                                                    type: 'error',
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    buttonsStyling: false
                                                })
                                            }
                                        })

                                    }
                                    else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        })
                                    }
                                })
                            });
                        });
                    });

                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                }

            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].vehicles;
                    // this.salesVehicles.forEach(vehicle => {
                    //     vehicle.actualTaxes = [];
                    //     vehicle.actualExpenses = [];
                    //     vehicle.actualTravels = [];
                    // });
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pymeTransportCosts.length != 0) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pymeTransportCosts[0].vehicles;
                    this.totalCostsPyme = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pymeTransportCosts[0].totalCosts;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    this.salesVehicles.forEach(vehicle => {
                        vehicle.totalTravels = 0;
                        vehicle.totalExpenses = 0;
                        vehicle.totalTaxes = 0;
                        vehicle.actualTaxes = [];
                        vehicle.actualExpenses = [];
                        vehicle.actualTravels = [];

                        // var qty = this.getTotalRouteQuantity(vehicle);
                        // Agregar datos a actualTravels
                        vehicle.routes.forEach(route => {
                            for (let i = 0; i < this.travels.length; i++) {
                                vehicle.actualTravels.push({
                                id: this.travels[i].id,
                                name: this.travels[i].name + '-' + route.routeName,
                                quantity: route.routeQuantity,
                                value: 0,
                                total: 0,
                                locked: true
                                });
                            }
                        });
                        // for (let i = 0; i < this.travels.length; i++) {
                        //     vehicle.actualTravels.push({
                        //     id: this.travels[i].id,
                        //     name: this.travels[i].name,
                        //     quantity: 0,
                        //     value: 0,
                        //     total: 0,
                        //     locked: true
                        //     });
                        // }

                        // Agregar datos a actualExpenses
                        for (let i = 0; i < this.expenses.length; i++) {
                            vehicle.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: 'Mensual',
                            month: 'Todos',
                            value: 0,
                            locked: true
                            });
                        }

                        // Agregar datos a actualTaxes
                        for (let i = 0; i < this.taxes.length; i++) {
                            vehicle.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                            });
                        }
                    });

                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].vehicles;
                    // this.salesVehicles.forEach(vehicle => {
                    //     vehicle.actualTaxes = [];
                    //     vehicle.actualExpenses = [];
                    //     vehicle.actualTravels = [];
                    // });
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pymeTransportCosts.length != 0) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pymeTransportCosts[0].vehicles;
                    this.totalCostsPyme = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pymeTransportCosts[0].totalCostsPyme;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    this.salesVehicles.forEach(vehicle => {
                        vehicle.totalTravels = 0;
                        vehicle.totalExpenses = 0;
                        vehicle.totalTaxes = 0;
                        vehicle.actualTaxes = [];
                        vehicle.actualExpenses = [];
                        vehicle.actualTravels = [];


                        // Agregar datos a actualTravels
                        vehicle.routes.forEach(route => {
                            for (let i = 0; i < this.travels.length; i++) {
                                vehicle.actualTravels.push({
                                id: this.travels[i].id,
                                name: this.travels[i].name + '-' + route.routeName,
                                quantity: route.routeQuantity,
                                value: 0,
                                total: 0,
                                locked: true
                                });
                            }
                        });
                        // for (let i = 0; i < this.travels.length; i++) {
                        //     vehicle.actualTravels.push({
                        //     id: this.travels[i].id,
                        //     name: this.travels[i].name,
                        //     quantity: 0,
                        //     value: 0,
                        //     total: 0,
                        //     locked: true
                        //     });
                        // }

                        // Agregar datos a actualExpenses
                        for (let i = 0; i < this.expenses.length; i++) {
                            vehicle.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: 'Mensual',
                            month: 'Todos',
                            value: 0,
                            locked: true
                            });
                        }

                        // Agregar datos a actualTaxes
                        for (let i = 0; i < this.taxes.length; i++) {
                            vehicle.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                            });
                        }
                    });
                }
            }
            else if(this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].vehicles;
                    // this.salesVehicles.forEach(vehicle => {
                    //     vehicle.actualTaxes = [];
                    //     vehicle.actualExpenses = [];
                    //     vehicle.actualTravels = [];
                    // });
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pymeTransportCosts.length != 0) {
                    this.salesVehicles = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pymeTransportCosts[0].vehicles;
                    this.totalCostsPyme = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pymeTransportCosts[0].totalCostsPyme;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    this.salesVehicles.forEach(vehicle => {
                        vehicle.totalTravels = 0;
                        vehicle.totalExpenses = 0;
                        vehicle.totalTaxes = 0;
                        vehicle.actualTaxes = [];
                        vehicle.actualExpenses = [];
                        vehicle.actualTravels = [];

                        // Agregar datos a actualTravels
                        vehicle.routes.forEach(route => {
                            for (let i = 0; i < this.travels.length; i++) {
                                vehicle.actualTravels.push({
                                id: this.travels[i].id,
                                name: this.travels[i].name + '-' + route.routeName,
                                quantity: route.routeQuantity,
                                value: 0,
                                total: 0,
                                locked: true
                                });
                            }
                        });
                        // for (let i = 0; i < this.travels.length; i++) {
                        //     vehicle.actualTravels.push({
                        //     id: this.travels[i].id,
                        //     name: this.travels[i].name,
                        //     quantity: 0,
                        //     value: 0,
                        //     total: 0,
                        //     locked: true
                        //     });
                        // }

                        // Agregar datos a actualExpenses
                        for (let i = 0; i < this.expenses.length; i++) {
                            vehicle.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: 'Mensual',
                            month: 'Todos',
                            value: 0,
                            locked: true
                            });
                        }

                        // Agregar datos a actualTaxes
                        for (let i = 0; i < this.taxes.length; i++) {
                            vehicle.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                            });
                        }
                    });
                }

            }
            this.calculateTotalCosts();
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
